/* istanbul ignore file */
/* istanbul ignore file */
import { EnumField, FieldProps, useFieldHelper } from 'framework/ui/field';
import React from 'react';
import { CandidateApplicationSourceTypeOptions } from 'domain/recruiting/candidate/applications/shared/candidateApplicationService';

const CandidateApplicationSourceTypeField = (props: FieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);

  return (
    <EnumField label={getLabel() || 'Source type'} value={getValue()} options={CandidateApplicationSourceTypeOptions} />
  );
};

export default CandidateApplicationSourceTypeField;
